import { render } from "./ManageInvitations.vue?vue&type=template&id=06a2954f"
import script from "./ManageInvitations.vue?vue&type=script&lang=js"
export * from "./ManageInvitations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__